export default {
  methods: {
    showLoading(id) {
      this.loading[id] = true
    },

    hideLoading(id) {
      this.loading[id] = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/loading.js